import Navbar from "./navbar/Navbar";
// import Footer from "./Footer";
import Background from "./Background";
import { Outlet } from 'react-router-dom'
import React from 'react'

const Layout = () => {
  return (<>
    <Navbar />
    <Outlet />
    <Background />
    {/* <Footer /> */}
  </>)
}

export default Layout